import type { ReceiptTemplate } from '../schema';

export const grailedTemplate: ReceiptTemplate = {
  id: 'grailed',
  name: 'Grailed Receipt',
  brand: 'GRAILED',
  description: 'Grailed marketplace receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'grailed-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/grailed.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'ORDER CONFIRMATION',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'grailed-order',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'Order:', value: 'GR-847291034' },
          { id: 'seller', label: 'Seller:', value: '@streetwear_mike' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'buyer', label: 'Buyer:', value: '@johndoe' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'grailed-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'RAF SIMONS HOODIE', quantity: '1', price: '450.00', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'grailed-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'item', label: 'ITEM', value: '450.00', isBold: false, isLarge: false },
          { id: 'shipping', label: 'SHIPPING', value: '12.00', isBold: false, isLarge: false },
          { id: 'fee', label: 'PROCESSING FEE', value: '13.86', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '475.86', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'grailed-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'PAYPAL',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'grailed-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'BUYER PROTECTION INCLUDED\n\nTHANK YOU FOR YOUR PURCHASE',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

